export const sizes = {
    margins_desk: "40px",
    marginmobile: "10px",
    marginsections: "60px",
    paddingsections_leftright: "5vw",
    sections_mob_margintop: "40px",
    sections_mob_marginsides: "10vw",
    sections_gap_desk: "5vw",
    sections_gap_desk: "3rem",
    columns_padding_desk: "15px",
    text_mob_gap: "20px",
    headerheight: "90px",
    headerhight_mobile: "70px",
    home1_desk_height: "75vh",
    home1_mob_height: "calc(90vh - 90px)",  //minus headerheight
    colorgreenalpha: "green",
    blockOneHeight: "75vh",
}